/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react'
import { StyledHeader } from './styles'
import prometheanLogo from './prometheanLogo.svg'
import fire from './fire.svg'

export const Header = (): React.ReactElement => {
  return (
    <StyledHeader className="OIDCHeader-root">
      <img src={prometheanLogo} alt="" className="OIDCHeader-prometheanLogo" />
      <img className="OIDCHeader-fire" src={fire} id="fire" alt="" />
    </StyledHeader>
  )
}

export default Header
